const consultingprofile = {
    getlist: 'consultingprofile/getlist-by-admin',
    get: 'consultingprofile/get-by-admin',
    add: 'consultingprofile/add-by-admin',
    update: 'consultingprofile/update-by-admin',
    accept: 'consultingprofile/accept',
    reject: 'consultingprofile/reject',
    setverified: 'consultingprofile/set-verified',
    remove: 'consultingprofile/remove',
}
export default consultingprofile
